<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Objectives</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Objectives</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="ptb--100 ">
  <div class="container">
    <div class="row justify-content-center gx-4">
      <div class="col-md-12">
        <ul class="list-before">
          <li>To develop a system for conscious, consistent and catalytic improvement in the overall performance of the
            institution.</li>
          <li>To channelize all efforts and measures of the institution towards promoting its holistic academic
            excellence.</li>
          <li>To ensure continuous improvement in the entire operations of the University.</li>
          <li>To ensure stakeholders connected with higher Education, namely parents, teachers, staff, would be
            employers, funding agencies and society in general, of its own quality and probity</li>
        </ul>
      </div>
    </div>
  </div>
</section>
